import React, { useState } from 'react';
import EditPersonalInfo from './modals/EditPersonalInfo';
import Dialog from '../../common/components/Dialog';
import { useTranslations } from '../../localization/useTranslations';

interface PersonalInfoProps {
  firstName: string;
  lastName: string;
  userEmail: string;
  avatarUrl: string;
  handleUserInfoChange: (updatedInfo: any) => void;
  userId: string | number;
  setIsSnackbarOpen: (value: boolean) => void;
  setSnackbarMessage: (message: string) => void;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({
  firstName,
  lastName,
  userEmail,
  avatarUrl,
  handleUserInfoChange,
  userId,
  setIsSnackbarOpen,
  setSnackbarMessage,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const translations = useTranslations();

  return (
    <div className="my-settings__section my-settings__section--personal-info">
      <div className="my-settings__section-header">
        <h4 className="my-settings__section-title">
          {translations.myAccountSettings.personalInformations || 'Personal Information'}
        </h4>
        <button
          id="personal-info"
          data-for="personal-info"
          className="my-settings__edit-button link link--medium"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          {translations.myAccountSettings.edit || 'Edit'}
        </button>
      </div>
      <div className="my-settings__section-content">
        <div className="my-settings__avatar-name-wrapper">
          <img id="personal-info-avatar" src={avatarUrl} alt="avatar" className="my-settings__avatar" />
          <div className="my-settings__column">
            <span className="my-settings__label basic basic-16">
              {translations.myAccountSettings.firstLastName || 'First & Last Name'}
            </span>
            <span id="personal-info-name" className="my-settings__text basic basic-16">
              {firstName && lastName ? `${firstName} ${lastName}` : '-'}
            </span>
          </div>
        </div>
        <div className="my-settings__column">
          <span className="my-settings__label basic basic-16">{translations.general.email || 'Email'}</span>
          <span id="personal-info-email" className="my-settings__text basic basic-16">
            {userEmail}
          </span>
        </div>
      </div>
      <Dialog isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <EditPersonalInfo
          firstName={firstName}
          lastName={lastName}
          avatarUrl={avatarUrl}
          onClose={() => setIsModalOpen(false)}
          isOpen={isModalOpen}
          handleUserInfoChange={handleUserInfoChange}
          userId={userId}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setSnackbarMessage={setSnackbarMessage}
        />
      </Dialog>
    </div>
  );
};

export default PersonalInfo;
